import type { PFrameInternal } from "@milaboratories/pl-model-middle-layer";
import type { IncomingMessage } from "node:http";

const PARQUET_FILENAME_REGEX = /^\/([\w\-.]+.parquet)$/;

export function getFilenameFromUrl(
  request: IncomingMessage,
): PFrameInternal.ParquetFileName | null {
  const url = request.url;
  if (url === undefined) return null;

  const match = url.match(PARQUET_FILENAME_REGEX);
  if (!match) return null;

  return match[1] as PFrameInternal.ParquetFileName;
}
